import { UnreadTickets } from "@accurx/api/ticket";
import { httpClient2 } from "@accurx/shared";

export const getUnreadTickets = async (
    workspaceId: number,
): Promise<UnreadTickets> => {
    return await httpClient2
        .get({
            path: "/api/conversation/web/unreadtickets",
            query: `?organisationId=${workspaceId}`,
        })
        .json<UnreadTickets>();
};
